// License: copied from https://github.com/tinymce/tinymce-react
// TODO: fix tinymce types
/**
 * Retrieves the global TinyMCE instance from a given window object, if available.
 *
 * @param {Window} view - The window from which to extract the TinyMCE instance.
 * @returns {any | null} The TinyMCE instance if found, otherwise `null`.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const getTinymce = (view) => {
    // TODO: fix tinymce types
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const global = view;
    return global && global.tinymce ? global.tinymce : null;
};
export { getTinymce };
